import React from 'react';

function Home(){
    return (
        <div>
            <p>This is where a Homepage will be will be</p><br />
            <p>needs a sign up for game page</p>
        </div>
    )

}
export default Home;